import { useCallback, useEffect, useState } from 'react';
import { getChannels, createChannel, deleteChannel } from 'api';

export const useChannels = () => {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        setLoading(true);
        const data = await getChannels();
        if (active) setChannels(data);
      } catch (e) {
        if (active) setError(e.message);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  const addChannel = useCallback(async (name) => {
    const channel = await createChannel(name);
    setChannels((prev) => [...prev, channel]);
    return channel;
  }, []);

  const removeChannel = useCallback(async (channelId) => {
    await deleteChannel(channelId);
    setChannels((prev) => prev.filter((channel) => channel.id !== channelId));
  }, []);

  return { channels, loading, error, addChannel, removeChannel };
};
